<template>
  <div class="page page-light page-piatti-vini">
    <div class="page__wrap p-top-xxxl-1 p-bottom-xl-1" data-animate="page-wrap">
      <PagesMenuNavigationList
        v-if="validMenus?.length"
        :menu-categories="validMenus"
      />

      <PagesCommonTextHeader
        v-if="page"
        :title="page.title"
        :is-alternative="
          !!(validMenuCategories?.length && !page.hideSubCategoriesSidebar)
        "
      />

      <div class="page-piatti-vini-wrap" data-animate="preloader-opacity">
        <!-- Sottocategorie del Menu-->
        <PagesMenuSubcategoriesList
          v-if="validMenuCategories?.length && !page.hideSubCategoriesSidebar"
          :category="route.params.category"
          :subcategories="validMenuCategories"
        />

        <div class="page-piatti-vini-main">
          <div
            v-if="page.intro"
            v-html="page.intro"
            class="page-piatti-vini-main-intro text-corpo-xxl"
            :class="{
              'is-text-center':
                !validMenuCategories?.length || page.hideSubCategoriesSidebar,
              'text-corpo-l-2':
                route.path.includes('wine-list') ||
                route.path.includes('carta-dei-vini'),
            }"
          />

          <!-- Prodotti figli diretti del Menu -->
          <div v-if="actualProductsObj">
            <PagesMenuProductsList
              :actual-sub-category="actualProductsObj"
              :is-centered="true"
              :excluded-ids="excludedIds"
            />
          </div>
        </div>
      </div>

      <!-- Body -->
      <template v-if="page?.body && page.body?.length">
        <PagesCommonBody :body-items="page.body" :touch="touch" />
      </template>
      <PagesCommonNewsSection :data="data.home.hero.cards" />
    </div>
  </div>
</template>

<script setup>
import queries from '@/graphql/dato/queries/index.js'
import pageTransition from '@/assets/js/transitions/helper.js'
import { useDatoStore } from '@/store/dato.js'

const { menuCategories, menuTree, menusCustom } = useDatoStore()

definePageMeta({
  layout: 'default',
  pageTransition,
})

const { locale } = useI18n()
const localePath = useLocalePath()
const touch = ref(false)
const route = useRoute()

const query = queries.piattiVini.getMenuCategory
const variables = computed(() => ({
  locale: locale.value,
  category: route.params.category,
}))

const { data } = await useGraphql(query, variables)

if (!data.value?.menuCategory) {
  throw createError({ statusCode: 404 })
}

onMounted(() => {
  touch.value = 'ontouchstart' in window || !!navigator.maxTouchPoints /// !! trasformano 0/1 in Bool
})

const page = computed(() => data.value?.menuCategory)
const seo = computed(() => data.value?.menuCategory?.seo || {})

const excludedIds = computed(() =>
  data.value?.menuCategory?.excludedIds
    ? data.value?.menuCategory?.excludedIds
    : '',
)

// Tutti i Menu validi
const validMenus = computed(() =>
  data?.value?.allMenuCategories.filter(
    (menuCategory) =>
      menuCategories.categorie?.some(
        (category) => menuCategory.idGestionale == category.id,
      ) ||
      menusCustom.some((menu) => menu.nome === menuCategory.menuCustomCode),
  ),
)

// Tutte le sottocategorie per il Menu attuale
const validMenuCategories = computed(() => {
  const idBirreWrong = 95
  const menuCategoryNode =
    useMenuUtils().findNodeById(
      menuTree,
      data.value?.menuCategory?.idGestionale,
    ) || {}
  const categoryNodeObj = {
    ...menuCategoryNode,
    children: menuCategoryNode.children?.filter(
      (child) => child.id !== idBirreWrong,
    ),
  }
  return categoryNodeObj ? categoryNodeObj.children : []
})

// Tutti i Prodotti figli diretti della Categoria attuale
const actualProductsObj = computed(() => {
  const menuCustom = menusCustom.find(
    (menu) => menu.nome === data.value?.menuCategory.menuCustomCode,
  )
  const parsedMenuCustom = menuCustom
    ? { ...menuCustom, products: menuCustom.prodotti }
    : null
  const categoryNode =
    useMenuUtils().findNodeById(
      menuTree,
      data.value?.menuCategory.idGestionale,
    ) || parsedMenuCustom
  return categoryNode ? categoryNode : {}
})

const localeParams = computed(
  () => data.value?.menuCategory?._allSlugLocales || [],
)

// Seo
useSeo({
  ...seo.value,
  localeParams: useHelpers().generateSeoLocaleParams(localeParams, 'category'),
})
</script>
